import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Typography from '@mui/material/Typography';
import { DataGrid } from '@mui/x-data-grid';
import { downloadFile, downloadPDFFile } from '../../../_utils/download_file.util';
import IconButton from '@mui/material/IconButton';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { findSellerOrdersEvent } from '../../../_events/sellers/find_orders.event';
import { displayPDFOrderEvent } from '../../../_events/orders/order_box.event';
import { message } from "antd";
import SellerOrdersGroupDate from "./group_date";
import SellerOrdersGroupClient from "./group_client";
import { Button } from "@mui/material";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    bgcolor: 'background.paper',
    border: '2px solid #fff',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
};

const panels = {
    info: "info",
    group_date: "group_date",
    group_client: "group_client",
}

const SellerOrders = () => {

    const [panel, setPanel] = React.useState(panels.info);

    const render_panel = () => {
        if(panel === panels.group_date){
            return <SellerOrdersGroupDate goBack={() => setPanel(panels.info)} />
        } else if(panel === panels.group_client){
            return <SellerOrdersGroupClient goBack={() => setPanel(panels.info)} />
        }
        else{
            return <Info columns={columns} />
        }
    }

    const displayPDF = (order) => {
        if(! order) message.error('No hay orden');
        else {
            let o = Object.assign({}, order);
            displayPDFOrderEvent(o)
            .then(data => {
                downloadPDFFile(data.data.toAproveJSON, `pedido_${order.id}`);
            })
            .catch(err => {
                message.error(err.message);
            });
        }    
    }

    const columns = [
        { field: 'uuid', headerName: '', width: 10, sortable: false,
            renderCell: (params) => {
                return(
                    <IconButton style={{marginRight: '10px'}} color="primary" aria-label="pdf" 
                        onClick={(e) => {e.stopPropagation(); displayPDF(params.row);}}>
                        <PictureAsPdfIcon />
                    </IconButton>
                );
            }
        },
        { field: 'id', headerName: 'Número', width: 100 },
        { field: 'purchase_order', headerName: 'OC', width: 100 },
        { field: '', headerName: 'Cliente', width: 300, sortable: false,
        valueGetter: (params) => params.row.ordersDetail ? params.row.ordersDetail.length > 0 ? params.row.ordersDetail[0].productPrice ? params.row.ordersDetail[0].productPrice.client ? params.row.ordersDetail[0].productPrice.client.name : '' : '' : '' : '',
            renderCell: (params) => {
                return <span>{params.row.ordersDetail ? params.row.ordersDetail.length > 0 ? params.row.ordersDetail[0].productPrice ? params.row.ordersDetail[0].productPrice.client ? params.row.ordersDetail[0].productPrice.client.name : '' : '' : '' : ''}</span>;
            }
        },
    ];

    return(
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                <div style={{display: 'flex', flexDirection: 'row', width:'100%'}}>
                    <Typography variant="h6" component="h6">
                        Pedidos pendientes
                    </Typography>
                    {
                        /*
                        <Button style={{marginLeft: '15px'}} variant="contained" size="small" onClick={() => setPanel(panels.group_date)}>Agrupación fecha</Button>
                        */
                    }
                    <Button style={{marginLeft: '15px'}} variant="contained" size="small" onClick={() => setPanel(panels.group_client)}>Agrupación cliente</Button>
                </div>
                <hr />
                {render_panel()}             
            </Grid>
        </Grid>
    );
}

const Info = (props) => {

    const [data, setData] = useState([]);

    const findData = () => {
        findSellerOrdersEvent()
        .then(data => {
            setData(data.list);
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    useEffect(() => {
        findData();
    }, []);   

    return(
        <div style={{height:450, width: '100%' }}>
            <DataGrid
                rows={data}
                columns={props.columns}
                pageSize={8}
                rowsPerPageOptions={[8]}
                checkboxSelection={false}
                getRowId={(p) => p.uuid}
            />
        </div>
    );
}

export default SellerOrders;